const generic=[

    {
    label:"WHO Performance status",
    controlType:"dropdown",
    options:["0","1","2","3","4","5"], 
    required:true 
    },
    
    {
    label:"Patient contact phone number (if different from primary care record)",
    controlType:"text",
    options:[]
    },

    {
    label:"Has the patient been informed that they are being referred on an RDC pathway",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    
    {
    label:"Has the patient been informed that their first contact may be a telephone consultation?",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {
    label:"Has the patient been informed that their next attendance may include a diagnostic investigation?",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {
    label:"Has the patient been given suspected cancer referral information? (postcard or text",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {
    label:"Has the patient consented to this referral and to sharing their relevant information?",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {
    label:"If the patient requires and interpreter please state language required",
    controlType:"text",
    options:[]
    },

    {
    label:"Please detail any additional patient support required due to congitive or sensory impairment",
    controlType:"text area",
    options:[]
    },

    {
    label:"Is there any date period when the patient is unavailable?:-  From:",
    controlType:"date",
    options:[]
    },

    {
    label:"Unavailable until:",
    controlType:"date",
    options:[]
    },

    


   
]

export default generic